import { render } from "./video-teacher.vue?vue&type=template&id=e18ab7b8&scoped=true"
import script from "./video-teacher.vue?vue&type=script&lang=js"
export * from "./video-teacher.vue?vue&type=script&lang=js"

import "./video-teacher.vue?vue&type=style&index=0&id=e18ab7b8&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\shview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e18ab7b8"]])

export default __exports__